import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getEstimate } from '../../api/estimatesAPI';
import { formatDateTime, formatDecimal } from '../../utils/dateUtils';
import { formatPhoneNum } from '../../utils/phoneUtils';
import PrintMenu from '../layout/PrintMenu';


export default function ViewEstimate() {
  const { eid } = useParams();
  const [estimate, setEstimate] = useState({});
  const [estimateOwner, setEstimateOwner] = useState(null);
  const [taxExempt, setTaxExempt] = useState({});
  const [vehicle, setVehicle] = useState();
  const [branch, setBranch] = useState();

  const boldStyle = {
    fontWeight:'bold',
  }

  const boldRightAlignStyle = {
    fontWeight:'bold',
    textAlign:'right',
  }

  const fontSize12Style = {
    fontSize:'12px',
  }

  async function handleEstimateGet() {
    try {
      const response = await getEstimate(eid);
      const estimateData = response.data;
      setEstimate(estimateData);
      setVehicle(estimateData.vehicle)
      setEstimateOwner(
        estimateData.estimate_owner_details.name +
        (estimateData.estimate_owner_details.tax_exempt ? " (Tax Exempt)" : "")
      );
      setTaxExempt(estimateData.estimate_owner_details.tax_exempt)
      setBranch(estimateData.branch_details)
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    handleEstimateGet();
  }, []);


  return (
    // TODO: Allow different customers to have different "Service Estimate" templates
    <>
      <PrintMenu />
      <Box sx={{textAlign: 'center', margin: '-25px auto 0', width: '670px'}}>
        {/* Estimate Header - Business and Vehicle Info */}
        <Typography variant='h1' sx={{fontSize: '28px', mb:1}}>SERVICE ESTIMATE</Typography>
        {branch?.name && <Typography sx={{fontSize: '16px', fontWeight: 600}}>{branch?.name}</Typography>}
        {branch?.address && <Typography sx={{fontSize: '14px'}}>{branch.address}</Typography>}
        {branch?.phone && <Typography sx={{fontSize: '14px'}}>{formatPhoneNum(branch.phone)}</Typography>}
        <Box sx={{display:'flex', justifyContent:'space-between', my:1}}>
          <Box sx={{flex: 1}}>
            <Typography fontSize='.85rem'><b>Last Updated</b></Typography>
            <Typography fontSize='.85rem'>{formatDateTime(estimate.updated_at)}</Typography>
          </Box>
          <Box sx={{flex: 1}}>
            <Typography fontSize='.85rem'><b>Year/Make/Model</b></Typography>
            {vehicle?.short_description && <Typography fontSize='.85rem'>{vehicle.short_description}</Typography>}
          </Box>
          <Box sx={{flex: 1}}>
            <Typography fontSize='.85rem'><b>VIN #</b></Typography>
            <Typography fontSize='.85rem'>{vehicle?.vin ?? 'N/A'}</Typography>
          </Box>
        </Box>
        <br/>
        {/* Estimate Pricing Details */}
        <Typography variant='h2' sx={{fontSize: '20px'}}>Service Information</Typography>
        <TableContainer>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell sx={boldStyle}>DESCRIPTION</TableCell>
                <TableCell sx={boldRightAlignStyle}>QTY</TableCell>
                <TableCell sx={boldRightAlignStyle}>PARTS</TableCell>
                <TableCell sx={boldRightAlignStyle}>LABOR</TableCell>
                <TableCell sx={boldRightAlignStyle}>TOTAL</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {estimate.estimate_items && estimate.estimate_items.map((item, index) => (
                <TableRow key={item.id}>
                  <TableCell>{item.description}</TableCell>
                  <TableCell sx={{textAlign:'right'}}>{item.quantity}</TableCell>
                  <TableCell sx={{textAlign:'right'}}>${formatDecimal(item.part_price)}</TableCell>
                  <TableCell sx={{textAlign:'right'}}>${formatDecimal(item.labor_price)}</TableCell>
                  <TableCell sx={{textAlign:'right'}}>${formatDecimal(item.estimate_item_total)}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell sx={boldStyle}>SUB-TOTALS</TableCell>
                <TableCell sx={boldRightAlignStyle}></TableCell>
                <TableCell sx={boldRightAlignStyle}>${formatDecimal(estimate.parts_total)}</TableCell>
                <TableCell sx={boldRightAlignStyle}>${formatDecimal(estimate.labor_total)}</TableCell>
                <TableCell sx={boldRightAlignStyle}>${formatDecimal(estimate.estimate_subtotal)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={boldStyle}>SALES TAX ({taxExempt ? "Exempt" : "5.5%"})</TableCell>
                <TableCell sx={boldRightAlignStyle}></TableCell>
                <TableCell sx={boldRightAlignStyle}></TableCell>
                <TableCell sx={boldRightAlignStyle}></TableCell>
                <TableCell sx={boldRightAlignStyle}>${formatDecimal(estimate.sales_tax_total)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={boldStyle}>ESTIMATE TOTAL</TableCell>
                <TableCell sx={boldRightAlignStyle}></TableCell>
                <TableCell sx={boldRightAlignStyle}></TableCell>
                <TableCell sx={boldRightAlignStyle}></TableCell>
                <TableCell sx={boldRightAlignStyle}>${formatDecimal(estimate.estimate_total)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <br />
        {/* Extra Estimate Conditions */}
        <Typography sx={{border: '2px solid black', fontSize: '12px'}}>
          THIS PRICE FOR THE AUTHORIZED REPAIRS WILL NOT BE EXCEEDED IF THE MOTOR VEHICLE IS DELIVERED TO THE SHOP
          WITHIN 5 DAYS
        </Typography>
        <br/>
        <Typography sx={{border: '2px solid black', fontSize: '12px'}}>
          TO KEEP YOUR FINAL BILL DOWN, SOME PARTS MAY BE RETURNED TO THE MANUFACTURER, BUT ALL PARTS WILL BE NEW UNLESS
          OTHERWISE SPECIFIED
        </Typography>
        <br/>
        <Box sx={{border: '2px solid black', padding: '5px'}}>
          <Box sx={{display: 'inline-block', width: '70%', marginRight: '10px', textAlign: 'left'}}>
            <Typography sx={fontSize12Style}>
              YOU ARE ENTITLED TO A PRICE ESTIMATE FOR THE REPAIRS YOU HAVE AUTHORIZED. THE REPAIR PRICE MAY BE LESS
              THAN THE ESTIMATE, BUT WILL NOT EXCEED THE ESTIMATE WITHOUT YOUR PERMISSION. YOUR SIGNATURE WILL INDICATE
              YOUR ESTIMATE SELECTION.
            </Typography>
            <br/>
            <Typography sx={fontSize12Style}>
              1. I request an estimate in writing before you begin repairs
            </Typography>
            <hr/>
            <Typography sx={fontSize12Style}>
              2. Please proceed with repairs, but call me before continuing if the price will exceed $_________________
            </Typography>
            <hr/>
            <Typography sx={fontSize12Style}>
              3. I do not want an estimate.
            </Typography>
            <hr/>
          </Box>

          <Box sx={{border: '2px solid black', display: 'inline-block', width: '25%'}}>
            <Typography sx={fontSize12Style}>
              Motor vehicle repair practices are regulated by chapter ATCP 132, Wis. Adm. Code, administered by the
              Bureau of Consumer Protection, Wisconsin Dept. of Agriculture, Trade and Consumer Protection, P.O. Box
              8911, Madison, Wisconsin 53708-8911.
            </Typography>
          </Box>

          <Box>
            <Box sx={{display: 'inline-block', width: '50%', textAlign: 'left'}}>
              <Typography sx={fontSize12Style}>CHECK ONE:</Typography>
              <Typography sx={fontSize12Style}>[ ] I DO WANT OLD PARTS RETURNED</Typography>
              <Typography sx={fontSize12Style}>[ ] I DO NOT WANT OLD PARTS RETURNED</Typography>
            </Box>
            <Box sx={{display: 'inline-block', width: '50%'}}>
              <Typography sx={fontSize12Style}>Prepared for: {estimateOwner ? estimateOwner : 'n/a'}</Typography>
              <Typography sx={{ ...fontSize12Style, mt:1.5 }}>SIGNATURE ___________________________________</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}